// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__an676","gridsContainer":"Skills_gridsContainer__KG+o6"};